<template>
  <div class="new-trial">
    <div class="plan-info">
      <div class="plan-details">
        <span class="plan-name">Teste Grátis</span>
        <span class="trial-info">3 dias grátis, depois R$ 97,00/mês</span>
      </div>
    </div>
    <legend>Informações fiscais</legend>
    <fieldset>
      <div class="row">
        <div class="col-12">
          <div class="form-check form-check-inline mb-3">
            <input
              class="form-check-input"
              type="radio"
              name="kind-of-person"
              id="kind-of-person-NATURAL_PERSON"
              value="NATURAL_PERSON"
              v-model="fiscalInfo.kindOfPerson"
              required
            />
            <label class="form-check-label" for="kind-of-person-NATURAL_PERSON"
              >Pessoa física</label
            >
          </div>
          <div class="form-check form-check-inline mb-3">
            <input
              class="form-check-input"
              type="radio"
              name="kind-of-person"
              id="kind-of-person-LEGAL_PERSON"
              value="LEGAL_PERSON"
              v-model="fiscalInfo.kindOfPerson"
              required
            />
            <label class="form-check-label" for="kind-of-person-LEGAL_PERSON"
              >Pessoa jurídica</label
            >
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group mb-3">
            <label for="legal-name" class="form-label">
              {{
                fiscalInfo.kindOfPerson === "NATURAL_PERSON"
                  ? "Nome completo"
                  : "Razão Social"
              }}
            </label>
            <div class="input-group">
              <input
                id="legal-name"
                type="text"
                class="form-control"
                v-model="fiscalInfo.legalName"
                required
              />
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group mb-3">
            <label for="reg-number" class="form-label">
              {{
                fiscalInfo.kindOfPerson === "NATURAL_PERSON" ? "CPF" : "CNPJ"
              }}
            </label>
            <div class="input-group">
              <input
                id="reg-number"
                v-maska="
                  fiscalInfo.kindOfPerson === 'NATURAL_PERSON'
                    ? '###.###.###-##'
                    : '##.###.###/####-##'
                "
                type="text"
                class="form-control"
                v-model="fiscalInfo.regNumber"
                required
              />
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group mb-3">
            <label for="address-line-1" class="form-label">Endereço</label>
            <div class="input-group">
              <input
                id="address-line-1"
                type="text"
                class="form-control"
                autocomplete="address-line1"
                v-model="fiscalInfo.addressLine1"
                required
              />
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group mb-3">
            <label for="address-number" class="form-label">Número</label>
            <div class="input-group">
              <input
                id="address-number"
                type="text"
                class="form-control"
                v-model="fiscalInfo.addressNumber"
                required
              />
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group mb-3">
            <label for="address-line-2" class="form-label">Complemento</label>
            <div class="input-group">
              <input
                id="address-line-2"
                type="text"
                class="form-control"
                autocomplete="address-line2"
                v-model="fiscalInfo.addressLine2"
              />
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group mb-3">
            <label for="address-line-3" class="form-label">Bairro</label>
            <div class="input-group">
              <input
                id="address-line-3"
                type="text"
                class="form-control"
                autocomplete="address-level3"
                v-model="fiscalInfo.addressLine3"
                required
              />
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group mb-3">
            <label for="city" class="form-label">Cidade</label>
            <div class="input-group">
              <input
                id="city"
                type="text"
                class="form-control"
                v-model="fiscalInfo.city"
                required
              />
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group mb-3">
            <label for="state" class="form-label">Estado</label>
            <div class="input-group">
              <select
                id="state"
                class="form-select"
                v-model="fiscalInfo.state"
                required
              >
                <option value="AC">Acre</option>
                <option value="AL">Alagoas</option>
                <option value="AP">Amapá</option>
                <option value="AM">Amazonas</option>
                <option value="BA">Bahia</option>
                <option value="CE">Ceará</option>
                <option value="DF">Distrito Federal</option>
                <option value="ES">Espírito Santo</option>
                <option value="GO">Goiás</option>
                <option value="MA">Maranhão</option>
                <option value="MT">Mato Grosso</option>
                <option value="MS">Mato Grosso do Sul</option>
                <option value="MG">Minas Gerais</option>
                <option value="PA">Pará</option>
                <option value="PB">Paraíba</option>
                <option value="PR">Paraná</option>
                <option value="PE">Pernambuco</option>
                <option value="PI">Piauí</option>
                <option value="RJ">Rio de Janeiro</option>
                <option value="RN">Rio Grande do Norte</option>
                <option value="RS">Rio Grande do Sul</option>
                <option value="RO">Rondônia</option>
                <option value="RR">Roraima</option>
                <option value="SC">Santa Catarina</option>
                <option value="SP">São Paulo</option>
                <option value="SE">Sergipe</option>
                <option value="TO">Tocantins</option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group mb-3">
            <label for="postal-code" class="form-label">CEP</label>
            <div class="input-group">
              <input
                id="postal-code"
                type="text"
                class="form-control"
                v-maska="'#####-###'"
                v-model="fiscalInfo.postalCode"
                required
              />
            </div>
          </div>
        </div>
      </div>
    </fieldset>
    <!-- Novo fieldset para cartão de crédito -->
    <legend class="mt-4">Informações do cartão de crédito</legend>
    <fieldset>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group mb-3">
            <label for="card-number" class="form-label">Número do cartão</label>
            <input
              id="card-number"
              type="text"
              class="form-control"
              v-model="creditCard.number"
              v-maska="'#### #### #### ####'"
              maxlength="19"
              required
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group mb-3">
            <label for="card-holder-name" class="form-label"
              >Nome como está no cartão</label
            >
            <input
              id="card-holder-name"
              type="text"
              class="form-control"
              v-model="creditCard.holderName"
              required
            />
          </div>
        </div>
        <div class="col-4">
          <div class="form-group mb-3">
            <label for="expiry-month" class="form-label"
              >Mês de expiração</label
            >
            <input
              id="expiry-month"
              type="text"
              class="form-control"
              v-model="creditCard.expiryMonth"
              maxlength="2"
              required
            />
          </div>
        </div>
        <div class="col-4">
          <div class="form-group mb-3">
            <label for="expiry-year" class="form-label">Ano de expiração</label>
            <input
              id="expiry-year"
              type="text"
              class="form-control"
              v-model="creditCard.expiryYear"
              maxlength="4"
              required
            />
          </div>
        </div>
        <div class="col-4">
          <div class="form-group mb-3">
            <label for="ccv" class="form-label"
              >Código de segurança (CCV)</label
            >
            <input
              id="ccv"
              type="text"
              class="form-control"
              v-model="creditCard.ccv"
              maxlength="4"
              required
            />
          </div>
        </div>
      </div>
    </fieldset>
    <div class="mt-4">
      <div v-if="errorMessage" class="alert alert-danger">
        {{ errorMessage }}
      </div>
      <div v-if="successMessage" class="alert alert-success">
        {{ successMessage }}
      </div>
      <button
        v-if="!successMessage"
        class="btn btn-submit btn-primary"
        :disabled="loading"
        @click="submitTrial"
      >
        Assinar e começar teste grátis
      </button>
    </div>
    <div class="trial-note mb-4">
      Nenhum valor será cobrado durante o período de teste gratuito.
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useMutation } from "@vue/apollo-composable";
import { gql } from "@apollo/client/core";
import { ClientError, getMessageFromError } from "@/libs/errors";

const props = defineProps(["user", "subscriptions"]);
// Removido: const emit = defineEmits(["trialActivated"]);

const loading = ref(false);
const errorMessage = ref("");
const successMessage = ref(""); // novo estado para mensagem de sucesso

const fiscalInfo = ref({
  kindOfPerson: props.user?.kindOfPerson ?? "NATURAL_PERSON",
  legalName: props.user?.legalName ?? "",
  regNumber: props.user?.regNumber ?? "",
  addressLine1: props.user?.addressLine1 ?? "",
  addressNumber: props.user?.addressNumber ?? "",
  addressLine2: props.user?.addressLine2 ?? "",
  addressLine3: props.user?.addressLine3 ?? "",
  city: props.user?.city ?? "",
  state: props.user?.state ?? "",
  postalCode: props.user?.postalCode ?? "",
});

const creditCard = ref({
  number: "",
  holderName: "",
  expiryMonth: "",
  expiryYear: "",
  ccv: "",
});

const { mutate: updateMyFiscalInfo } = useMutation(gql`
  mutation UpdateMyFiscalInfo($input: UpdateFiscalInfoInput!) {
    updateMyFiscalInfo(input: $input) {
      id
      kindOfPerson
      legalName
      regNumber
      postalCode
      addressLine1
      addressNumber
      addressLine2
      addressLine3
      city
      state
    }
  }
`);

const { mutate: subscribeTrialViaWeb } = useMutation(gql`
  mutation SubscribeTrialViaWeb($creditCardInput: CreditCardInput!) {
    subscribeTrialViaWeb(input: $creditCardInput)
  }
`);

const submitTrial = async () => {
  errorMessage.value = null;
  successMessage.value = ""; // Limpa mensagem de sucesso antes de submeter
  loading.value = true;
  try {
    await updateMyFiscalInfo({
      input: { ...fiscalInfo.value },
    });

    const creditCardInput = {
      ...creditCard.value,
      cardHolderName: fiscalInfo.value.legalName,
      cardHolderRegNumber: fiscalInfo.value.regNumber,
      cardHolderEmail: props.user?.email ?? "",
      cardHolderPhone: props.user?.phone ?? "",
      cardHolderPostalCode: fiscalInfo.value.postalCode,
      cardHolderAddressNumber: fiscalInfo.value.addressNumber,
      cardHolderAddressLine2: fiscalInfo.value.addressLine2 || "",
    };

    const { data } = await subscribeTrialViaWeb({
      creditCardInput,
    });
    loading.value = false;
    if (data && data.subscribeTrialViaWeb) {
      // Exibe mensagem de sucesso em vez de emitir evento
      successMessage.value =
        "Seu teste gratuito foi ativado com sucesso! Você já pode utilizar a plataforma.";
    } else {
      throw new ClientError(
        "Não foi possível iniciar seu teste gratuito. Tente novamente mais tarde."
      );
    }
  } catch (err) {
    errorMessage.value = getMessageFromError(err);
    loading.value = false;
  }
};
</script>

<style scoped>
.plan-info {
  padding: 14px 22px 14px 22px;
  background: #16161d;
  border-radius: 16px;
  text-align: center;
  max-width: 340px;
  margin: 24px auto;
}
.plan-details {
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: center;
}
.plan-name {
  color: #a6c715;
  font-weight: 700;
  font-size: 20px;
}
.trial-info {
  color: #c5c8d4;
  font-size: 14px;
}
.trial-actions {
  margin-top: 16px;
  text-align: center;
}
.trial-note {
  margin-top: 18px;
  font-size: 13px;
  color: #c5c8d4;
}
</style>
